import { Fetch } from '../Models/shared/general';

//#region ======== ACTIONS ========
const actions = {
    //====== ATTENDANCE =====
    attendance_attendance_create    : "attendance_attendance_create",
    attendance_checkin_create       : "attendance_checkin_create",
    attendance_checkout_update      : "attendance_checkout_update",
    attendance_dateuser_get         : "attendance_dateuser_get",

    //===== MANAGEMENT =====
    attendance_date_get             : "attendance_date_get",
    attendance_user_get             : "attendance_user_get",
    attendance_attendance_update    : "attendance_attendance_update"

};
//#endregion

//====== ATTENDANCE =====
export function attendance_attendance_create(data){
    return Fetch({ action: actions.attendance_attendance_create, data: data });
}

//20210817 Attendance CHECK IN
export function attendance_checkin_create(data){
    return Fetch({ action: actions.attendance_checkin_create, data: data });
}

//20210817 Attendance CHECK OUT
export function attendance_checkout_update(data){
    return Fetch({ action: actions.attendance_checkout_update, data: data });
}

export function attendance_dateuser_get(data){
    return Fetch({ action: actions.attendance_dateuser_get, data: data });
}

export function attendance_user_get(data){
    return Fetch({ action: actions.attendance_user_get, data: data })
}

//===== ATTENDANCE MANAGEMENT ========
export function attendance_date_get(data){
    return Fetch({ action: actions.attendance_date_get, data: data });
}

export function  attendance_attendance_update(data){
    return Fetch({ action: actions.attendance_attendance_update, data: data });
}